<template lang="pug">
.estado-vazio
  slot
    .estado-vazio-padrao
      img.estado-vazio-padrao__icone(src="../../../static/icones/caixaVazia.svg")
      p.estado-vazio-padrao__titulo {{ $t('compartilhados.SmartTable.EstadoVazio.mensagemErro') }}
      p.estado-vazio-padrao__descricao(v-if="descricao") {{ descricao }}
      .estado-vazio-padrao__acao(v-if="$slots.acao")
        slot(name="acao")
</template>

<script>
export default {
  name: 'EstadoVazio',
  props: {
    // Microcopy de orientação (próximo passo). Opcional — quando omitido, nada
    // é exibido. Ex.: "Ajuste os filtros ou tente uma busca diferente."
    descricao: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.estado-vazio {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);

  &-padrao {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;

    &__icone {
      width: 56px;
      opacity: 0.7;
    }

    &__titulo {
      color: var(--texto-forte);
      margin: 0;
      font-size: 1rem;
      font-weight: 600;
    }

    &__descricao {
      color: var(--texto-suave);
      margin: 0;
      font-size: 0.875rem;
      text-align: center;
    }

    &__acao {
      margin-top: 0.25rem;
    }
  }
}
</style>
